import React from "react";
import { useHistory, Link, NavLink } from "react-router-dom";
import Utils from "../../../Common/Utils";
import { VMContextProvider } from "../../../Components/Admin/VersionManagement/vmContext";
import VMManage from "../../../Components/Admin/VersionManagement/Manage";

function VersionManagementIndex(props) {
  const history = useHistory();

  React.useEffect(() => {
    Utils.SetWindowTitle("Version Management Queries");
  }, []);
  return (
    <React.Fragment>
      <VMContextProvider>
        <VMManage />
      </VMContextProvider>
    </React.Fragment>
  );
}

export default VersionManagementIndex;
